import { useLocation } from 'react-router'
import { languageService } from '#src/languageService.js'

/**
 * Whether a child route is rendered below the layout mounted at `canonicalBase`
 * (e.g. a gallery popup in its <Outlet/>) - the replacement for Next's
 * `useSelectedLayoutSegment()`. Compares against the canonical (language-stripped)
 * path, so it works for both the canonical and the localized (/sv/...) mount.
 */
export function useIsChildRoute(canonicalBase: string): boolean {
  const { pathname } = useLocation()
  return languageService.delocalizePath(pathname) !== canonicalBase
}
